<template>

  <div class="contact">
    <h2 class="title">Information about me </h2>
    <p>Hello I am Zebediah Montoya. Ever since I was
        little I have had an interest in computers and 
        how they work. I have attempted to understand how 
        the software and the hardware works on many different 
        systems, from the Commodore 64 to modern 64 bit computers.
    </p>

    <br>

    <h3 class="title is-3">Email Address</h3>
    <a class="title is-4">zebmontoya@gmail.com</a>


    <!--<form>
      <h4>Name</h4>
      <input class="input" type="text" placeholder="Enter Name"/>
      <h4>Email</h4>
      <input class="input" type="email" placeholder="Enter Email"/>
      <h4>Subject</h4>
      <input class="input" type="text" placeholder="Enter Subject"/>
      <h4>Message</h4>
      <textarea id="message" class="textarea" placeholder="Write Message Here"/>
      <br/>
      <div class="control">
        <button class="button is-link">Submit</button>
      </div>
    </form>
    -->
  </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button{
  margin: auto;
}
.input{
  margin-top: 10px;
  margin-bottom: 10px;
}
#message{
  padding-top: 10px;
  padding-bottom: 100px;
}
</style>
